export default {
  methods: {
    callInstallPrompt() {
      if (window.installPromptEvent !== undefined) {
        window.installPromptEvent.prompt();
      }
    }

  },
  id: '326d0640a9',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=addhome><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>Add to Home Screen</div></div></div><div class=page-content><div class="block block-strong no-hairlines-md margin-top-half"><p>This app was developed as a progressive web app (PWA), optimized for use in mobile devices and can be added to the Home screen of your android or iphone. Once added (&lt;5mb download) it can then be used with or without mobile/wifi data connection. When you do have data connection, the app will automatically check for incremental updates. Android and Windows desktop users get the default Material Design theme, whereas iOS users get the familiar iOS theme, icons and toggles, etc. Dark mode is automatically enabled corresponding to your phone setting.</p><p><b>Instructions for iOS users:</b></p><ol><li>While browsing this app in Safari, tap the "up-arrow" <i class=f7-icons style="font-size: 20px; color: #007aff">square_arrow_up</i> button in the browser</li><li>Scroll amongst the options and select "Add to Home Screen"</li></ol><p><b>Instructions for Android users:</b></p><ol><li>Android by default may automatically prompt "Add to Home screen" when you browse the app in your web browser</li><li>If not or you cancelled, try tapping <a href=# @click=callInstallPrompt>HERE</a></li><li>If above does not work, tap the "3-dot" <i class=f7-icons style="font-size: 20px;">ellipsis_vertical</i> button next to Chrome address field and select "Add to Home screen"</li></ol></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};